var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenLockSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 1.125C16.5107 1.125 13.5 4.13571 13.5 7.875V9H3.2959C2.0638 9 1.125 10.0638 1.125 11.25V22.5C1.125 23.6862 2.0638 24.75 3.2959 24.75H15.8291C17.0612 24.75 18 23.6862 18 22.5V11.25C18 10.0638 17.0635 9 15.8313 9H15.75V7.875C15.75 5.31429 17.6893 3.375 20.25 3.375C22.8107 3.375 24.75 5.31429 24.75 7.875V10.125H27V7.875C27 4.13571 23.9893 1.125 20.25 1.125ZM3.375 11.25H15.75V22.5H3.375V11.25ZM9.57129 14.625C8.33379 14.625 7.32129 15.6375 7.32129 16.875C7.32129 18.1125 8.33379 19.125 9.57129 19.125C10.8088 19.125 11.8213 18.1125 11.8213 16.875C11.8213 15.6375 10.8088 14.625 9.57129 14.625Z",
    fill: "#00479B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLockSvg);
export default __webpack_public_path__ + "static/media/OpenLockSVG.496d307761994abbbbdbd88caed5e7c3.svg";
export { ForwardRef as ReactComponent };